/*
 *   File : subscription-status.js
 *   Author : https://evoqins.com
 *   Description : Subscription modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo, useEffect, useState } from 'react';

// Assets
import KYCSuccess from "../../Assets/Images/Modal/kyc-success.webp";
import KYCFailed from "../../Assets/Images/Modal/kyc-failed.webp";
import AgreementSuccess from "../../Assets/Images/Modal/agreement-sign-success.webp";
import SubscriptionSuccess from "../../Assets/Images/Modal/subscription-success.webp";


//Custom components
import { Icon } from '../Icon';
import { PrimaryButton } from '../Buttons';

const SubscriptionStatusModal = (props) => {

    const [statusImg, setStatusImg] = useState("");
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [btnLabel, setBtnLabel] = useState("");


    useEffect(() => {

        // ModalType
        // KYC Verified === Type 1
        // KYC Not Verified === Type 2
        // Sign Successful === Type 3
        // Subscription Successful === Type 3

        if (props.type === 1) {
            setStatusImg(KYCSuccess);
            setTitle("KYC verified successfully");
            setDescription("You are a KYC verified user, Click continue to resume the subscription");
            setBtnLabel("Continue");
        } else if (props.type === 2) {
            setStatusImg(KYCFailed);
            setTitle("KYC Verification failed");
            setDescription("We are unable verify submitted details. Please complete KYC registration to continue");
            setBtnLabel("Go Back");

        } else if (props.type === 3) {
            setStatusImg(AgreementSuccess);
            setTitle("Agreement signed successfully");
            setDescription("Agreement signed successfully. Please proceed further to setup AutoPay.");
            setBtnLabel("Continue");

        } else if (props.type === 4) {
            setStatusImg(SubscriptionSuccess);
            setTitle("Subscription Successful!");
            setDescription("Investment options are now available for you to start investing in our exclusive baskets.");
            setBtnLabel("Start Investing");
        }
        else {
            setStatusImg(KYCSuccess);
            setTitle("Complete Your KYC Verification");
            setDescription("Please provide your PAN and Date of Birth to complete the KYC verification process and start investing seamlessly.");
            setBtnLabel("Verify Now");
        }

    }, [props.type]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("subscription-modal-close");
        button.click();
        props.handleClose();
    };

    // handle success
    const _handleSuccess = () => {
        _handleCloseModal();
        props.handleSuccess();
    };

    return (
        <div className="modal fade" id="subscription-modal"
            data-bs-backdrop="static" data-bs-keyboard="false"
            tabIndex="-1" aria-labelledby="subscriptionModalLabel"
            aria-hidden="true">

            <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-16 modal-lg px-lg-5`}>
                <span id='subscription-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-16 overflow-hidden border-0 mx-lg-5">
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-end align-items-center pt-3 px-3 pb-0">
                        <Icon icon="close-icon"
                            size="20px"
                            className="cursor-pointer"
                            onPress={_handleCloseModal} />
                    </div>
                    {/* Modal body */}
                    <div className='modal-body py-0 px-3 px-sm-4 text-center'>
                        <img src={statusImg}
                            draggable={false}
                            width={200}
                            alt='subscription' />

                        <h4 className='padding-12px-top mb-2 e-text-primary-color e-primary-font-clash-display e-font-18 e-font-weight-500 line-height-22px'>
                            {title}
                        </h4>
                        <p className='px-5 mb-0 e-alt-font-lato e-font-14 e-text-outer-space e-font-weight-400 line-height-20px'>
                            {description}
                        </p>
                    </div>
                    {/* Modal footer */}
                    <div className='modal-footer border-0 padding-40px-lr padding-20px-tb d-block'>
                        <PrimaryButton name={btnLabel}
                            className="w-100"
                            onPress={_handleSuccess} />
                    </div>
                </div>
            </div>
        </div>
    )
}

SubscriptionStatusModal.defaultProps = {
    handleClose: () => { },
    className: null,
};

export default memo(SubscriptionStatusModal);
